import { Component } from '@angular/core';

@Component({
  selector: 'app-column-container',
  templateUrl: './column-container.component.html',
  styleUrls: ['./column-container.component.scss'],
  standalone: false,
})
export class ColumnContainerComponent {}
